<template>
  <component class="footer-link" :is="linkElement" v-bind="linkProps">{{ text }}</component>
</template>

<script>
export default {
  name: 'FooterLink',
  props: {
    isSpa: { type: Boolean },
    target: { type: String },
    href: { type: String, required: true },
    text: { type: String, required: true },
  },

  computed: {
    linkElement() {
      return this.isSpa ? 'router-link' : 'a'
    },

    linkProps() {
      const hrefPropName = this.isSpa ? 'to' : 'href'
      return {
        [hrefPropName]: this.href,
        ...(this.target && { target: this.target }),
      }
    },
  },
}
</script>
